module.exports = __webpack_public_path__ + "c3d656a70829cdec1b6093fecca49154.fbx";